import "../lifehacks/ArticleFull.css";

const BackgroundCheckGuide = () => {
  return (
    <div className="article-full">
      <h1 className="article-title">Справки о несудимости для подачи в штате Санта-Катарина</h1>

      <p className="article-text">
        Для подачи заявления на ВНЖ и гражданство в Бразилии необходимо подготовить документы, подтверждающие отсутствие судимостей — как из России, так и из Бразилии. Обратите внимание: в разных штатах требования к количеству справок могут различаться. Уточняйте актуальную информацию на{" "}
        <a
          href="https://www.gov.br/pf/pt-br/assuntos/imigracao/declaracoes-e-formularios/certidoes-criminais"
          className="article-text"
          target="_blank"
          rel="noopener noreferrer"
        >
          официальном сайте
        </a>.
      </p>

      <div className="article-section">
        <h3 className="article-section-title">1. Российская справка о несудимости</h3>
        <p className="article-text">
          <ul>
            <li>Заказывается через консульство РФ в Бразилии (срок ожидания — около недели).</li>
            <li>Можно сразу запросить на португальском языке.</li>
            <li>Если у вас справка из РФ на русском языке: перевод у присяжного переводчика + нотариальное заверение (обычно переводчики помогают с организацией).</li>
          </ul>
        </p>
        <p className="article-section-info">
          Контакт проверенного переводчика (Сан-Пауло): Наталья Павлова — WhatsApp: +55 11 95 557 3009
        </p>
      </div>

      <div className="article-section">
        <h3 className="article-section-title">2. Бразильские справки</h3>
        <p className="article-text">
          Для Санта-Катарины требуется: справка общего назначения (<a href="https://www2.trf4.jus.br/trf4/processos/certidao/index.php" className="article-text"
          target="_blank"
          rel="noopener noreferrer">Criminal</a>), а также справки из судов (<a href="https://certidoes.tjsc.jus.br/pedidoCertidao"className="article-text"
          target="_blank"
          rel="noopener noreferrer">Primeiro Grau и Segundo Grau</a>). После регистрации на портале Gov.br может потребоваться уровень верификации “серебряный”.
        </p>
        <p className="article-text">
          Вместо номера RG вводим номер заграничного паспорта, и обязательно указать имя мамы и имя отца, несмотря на то, что имя отца необязательное поле (без звездочки).
        </p>
      </div>

      <div className="article-note">
        <p className="article-note-text">
          Раздел о бразильских справках постоянно обновляется. Рекомендуем уточнять информацию у тех, кто недавно подавал документы, или проконсультироваться с юристом.
        </p>
      </div>
    </div>
  );
};

export default BackgroundCheckGuide;